import { Form, Input, InputNumber, Modal, Select } from '@maxtropy/components';
import { useEffect, useState } from 'react';
import { TopologyLoadDeviceRecord } from './types';

type LoadDeviceFormValues = Pick<TopologyLoadDeviceRecord, 'name' | 'type' | 'ratedVoltage'>;

interface EditLoadDeviceModalProps {
  open: boolean;
  record?: TopologyLoadDeviceRecord;
  records?: TopologyLoadDeviceRecord[];
  onCancel: () => void;
  onOk: (values: TopologyLoadDeviceRecord) => void;
}

const deviceTypeOptions = [
  { label: '硅铁炉', value: 'FERROSILICON_FURNACE' },
  { label: '电石炉', value: 'CALCIUM_CARBIDE_FURNACE' },
];

const EditLoadDeviceModal = (props: EditLoadDeviceModalProps) => {
  const { open, record, records = [], onCancel, onOk } = props;
  const [form] = Form.useForm<LoadDeviceFormValues>();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const validateUniqueName = (_: unknown, value?: string) => {
    const name = value?.trim();

    if (!name) {
      return Promise.resolve();
    }

    const existingRecord = records.some(item => item.id !== record?.id && item.name === name);

    if (existingRecord) {
      return Promise.reject(new Error('负荷设备名称已存在'));
    }

    return Promise.resolve();
  };

  useEffect(() => {
    if (!open) {
      return;
    }

    if (record) {
      form.setFieldsValue(record);
      return;
    }

    form.resetFields();
  }, [form, open, record]);

  const handleOk = async () => {
    setConfirmLoading(true);
    const values = await form
      .validateFields()
      .then(res => res)
      .catch(() => null);
    setConfirmLoading(false);

    if (!values) {
      return;
    }

    onOk({
      id: record?.id ?? Date.now(),
      backendId: record?.backendId,
      relatedDevices: record?.relatedDevices ?? [],
      relatedDeviceIds: record?.relatedDeviceIds ?? [],
      ...values,
    });
  };

  return (
    <Modal
      title={record ? '编辑负荷设备' : '新增负荷设备'}
      open={open}
      width={520}
      contentClassName="modal-form-content"
      destroyOnClose
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form form={form} layout="horizontal" labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}>
        <Form.Item
          label="负荷设备名称"
          name="name"
          rules={[
            { required: true, whitespace: true, message: '请输入' },
            { min: 1, max: 50, message: '请输入1~50个字符' },
            { validator: validateUniqueName },
          ]}
        >
          <Input placeholder="请输入" maxLength={50} />
        </Form.Item>
        <Form.Item label="设备类型" name="type" rules={[{ required: true, message: '请选择' }]}>
          <Select placeholder="请选择" options={deviceTypeOptions} />
        </Form.Item>
        <Form.Item
          label="额定电压"
          name="ratedVoltage"
          rules={[
            { required: true, message: '请输入' },
            {
              type: 'number',
              min: 0,
              max: 99999999.99,
              message: '请输入0~99999999.99',
            },
          ]}
        >
          <InputNumber
            placeholder="请输入"
            addonAfter="V"
            style={{ width: '100%' }}
            min={0}
            max={99999999.99}
            precision={2}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditLoadDeviceModal;
